(() => {
  if (window.__pelykoSocialProofConversion3108) return;
  window.__pelykoSocialProofConversion3108 = true;

  const lifestyleImage = 'https://cdn.shopify.com/s/files/1/1009/4877/1160/files/pelyko-brosse-realistic-human-showcase.png?v=1788053708';

  const style = document.createElement('style');
  style.id = 'pelyko-social-proof-conversion-3108';
  style.textContent = `
    .pelyko-conversion-proof{display:flex;align-items:center;gap:8px;flex-wrap:wrap;margin:0 0 12px}
    .pelyko-conversion-rating,.pelyko-pdp-rating{display:inline-flex;align-items:center;gap:7px;flex-wrap:wrap;width:max-content;max-width:100%;padding:8px 11px;border:1px solid rgba(78,101,83,.18);border-radius:999px;background:rgba(255,255,255,.94);color:#111512;text-decoration:none;box-shadow:0 8px 24px rgba(28,42,31,.05)}
    .pelyko-conversion-rating__stars,.pelyko-pdp-rating__stars{color:#58725e;letter-spacing:1px;font-size:12px;line-height:1}
    .pelyko-conversion-rating strong,.pelyko-pdp-rating strong{font-size:12px;line-height:1}
    .pelyko-conversion-rating__label,.pelyko-pdp-rating__label{font-size:11px;color:#59645c;line-height:1}
    .pelyko-preview-tag{padding:3px 6px;border-radius:999px;background:#eef3ed;color:#607064;font-size:8px;font-weight:850;letter-spacing:.05em;text-transform:uppercase;line-height:1}
    .pelyko-selection-badge{display:inline-flex;align-items:center;gap:6px;padding:8px 12px;border:1px solid rgba(79,102,84,.2);border-radius:999px;background:#e7efe6;color:#3f5546;font-size:11px;font-weight:900;white-space:nowrap;box-shadow:0 8px 22px rgba(28,42,31,.04)}
    .pelyko-selection-badge:before{content:'✦';font-size:11px}

    .pelyko-home-hero.is-pelyko-conversion-home .pelyko-home-hero__title{max-width:650px!important;font-size:clamp(52px,6.3vw,86px)!important;line-height:.92!important;letter-spacing:-.06em!important;margin:0 0 10px!important}
    .pelyko-home-hero.is-pelyko-conversion-home .pelyko-home-hero__lead{max-width:560px!important;font-size:clamp(19px,1.7vw,24px)!important;line-height:1.2!important;font-weight:760!important;color:#526158!important;margin:0 0 14px!important}
    .pelyko-home-hero.is-pelyko-conversion-home .pelyko-fit-lines,.pelyko-home-hero.is-pelyko-conversion-home .pelyko-diff-chip{display:none!important}
    .pelyko-answer-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;max-width:700px;margin:0 0 17px}
    .pelyko-answer-card{min-width:0;padding:11px 12px;border:1px solid rgba(17,21,18,.09);border-radius:14px;background:rgba(255,255,255,.8);box-shadow:0 8px 24px rgba(28,42,31,.035)}
    .pelyko-answer-card b{display:block;margin:0 0 4px;color:#111512;font-size:11px;line-height:1.2}
    .pelyko-answer-card span{display:block;color:#59645c;font-size:10.5px;line-height:1.35}
    .pelyko-home-stage .pelyko-stage-card--main{overflow:hidden!important}
    .pelyko-home-stage .pelyko-stage-card--main img[data-pelyko-lifestyle='true']{width:100%!important;height:100%!important;object-fit:cover!important;object-position:center!important;filter:none!important;transform:none!important}
    .pelyko-lifestyle-caption{position:absolute;z-index:5;left:7%;bottom:7%;padding:8px 11px;border-radius:999px;background:rgba(17,21,18,.86);color:#fff;font-size:10px;font-weight:850;backdrop-filter:blur(8px);pointer-events:none}

    .pelyko-pdp.is-pelyko-conversion .pelyko-pdp-fit-quick,.pelyko-pdp.is-pelyko-conversion .pelyko-result-promise,.pelyko-pdp.is-pelyko-conversion .pelyko-difference-box{display:none!important}
    .pelyko-pdp-rating{margin:8px 0 10px;background:#f5f8f4;box-shadow:none}
    .pelyko-pdp-rating a{color:#435649;text-decoration:underline;text-underline-offset:2px;font-size:11px;font-weight:850}
    .pelyko-pdp-conversion-answers{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:7px;margin:0 0 16px}
    .pelyko-pdp-conversion-answer{padding:10px 11px;border:1px solid rgba(17,21,18,.09);border-radius:13px;background:#f8faf7}
    .pelyko-pdp-conversion-answer b{display:block;margin-bottom:4px;font-size:10px;line-height:1.15;color:#111512}
    .pelyko-pdp-conversion-answer span{display:block;font-size:9.5px;line-height:1.3;color:#5c685f}

    @media(max-width:720px){
      .pelyko-home-hero.is-pelyko-conversion-home .pelyko-kicker{display:none!important}
      .pelyko-home-hero.is-pelyko-conversion-home .pelyko-home-hero__title{font-size:44px!important;line-height:.93!important;max-width:340px!important;margin-top:2px!important}
      .pelyko-home-hero.is-pelyko-conversion-home .pelyko-home-hero__lead{font-size:18px!important;line-height:1.18!important;margin-bottom:10px!important}
      .pelyko-conversion-proof{gap:5px;margin-bottom:9px}
      .pelyko-conversion-rating{padding:7px 9px;gap:5px}
      .pelyko-conversion-rating__label{display:none}
      .pelyko-selection-badge{padding:7px 9px;font-size:10px}
      .pelyko-answer-grid{grid-template-columns:1fr;gap:5px;margin-bottom:10px}
      .pelyko-answer-card{display:grid;grid-template-columns:94px 1fr;align-items:center;gap:7px;padding:8px 10px;border-radius:11px}
      .pelyko-answer-card b{margin:0;font-size:10.5px}
      .pelyko-answer-card span{font-size:9.5px;line-height:1.25}
      .pelyko-home-hero.is-pelyko-conversion-home .pelyko-actions{margin-top:5px!important}
      .pelyko-home-hero.is-pelyko-conversion-home .pelyko-actions .pelyko-button--secondary{display:none!important}
      .pelyko-lifestyle-caption{left:5%;bottom:5%;font-size:9px}
      .pelyko-pdp-conversion-answers{grid-template-columns:1fr;gap:5px}
      .pelyko-pdp-conversion-answer{display:grid;grid-template-columns:96px 1fr;align-items:center;gap:7px;padding:8px 10px}
      .pelyko-pdp-conversion-answer b{margin:0;font-size:10px}
      .pelyko-pdp-conversion-answer span{font-size:9.5px}
    }
  `;
  document.head.appendChild(style);

  const addHome = () => {
    const hero = document.querySelector('.pelyko-home-hero');
    if (!hero) return;
    hero.classList.add('is-pelyko-conversion-home');
    const copy = hero.querySelector('.pelyko-home-hero__copy');
    const title = hero.querySelector('.pelyko-home-hero__title');
    const lead = hero.querySelector('.pelyko-home-hero__lead');
    if (!copy || !title || !lead) return;

    if (!copy.querySelector('.pelyko-conversion-proof')) {
      const proof = document.createElement('div');
      proof.className = 'pelyko-conversion-proof';
      proof.innerHTML = `
        <a class="pelyko-conversion-rating" href="#avis" aria-label="Voir les avis PELYKO">
          <span class="pelyko-conversion-rating__stars" aria-hidden="true">★★★★★</span>
          <strong>4,8/5</strong>
          <span class="pelyko-conversion-rating__label">Avis clients</span>
          <small class="pelyko-preview-tag">Aperçu</small>
        </a>
        <span class="pelyko-selection-badge">Sélection PELYKO</span>`;
      title.insertAdjacentElement('beforebegin', proof);
    }

    if (!copy.querySelector('.pelyko-answer-grid')) {
      const grid = document.createElement('div');
      grid.className = 'pelyko-answer-grid';
      grid.setAttribute('aria-label', 'Les trois réponses essentielles PELYKO');
      grid.innerHTML = `
        <div class="pelyko-answer-card"><b>C’est pour vous ?</b><span>Chien ou chat + poils au quotidien.</span></div>
        <div class="pelyko-answer-card"><b>Votre bénéfice</b><span>Moins de corvées. Plus de temps avec eux.</span></div>
        <div class="pelyko-answer-card"><b>Pourquoi PELYKO ?</b><span>4 gestes utiles. Pas de gadgets.</span></div>`;
      lead.insertAdjacentElement('afterend', grid);
    }

    const stage = hero.querySelector('.pelyko-home-stage');
    const mainImage = stage?.querySelector('.pelyko-stage-card--main img');
    if (mainImage && mainImage.dataset.pelykoLifestyle !== 'true') {
      mainImage.src = lifestyleImage;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.alt = 'Une personne profite d’une routine de brossage plus simple avec son chien et PELYKO';
      mainImage.loading = 'eager';
      mainImage.fetchPriority = 'high';
      mainImage.dataset.pelykoLifestyle = 'true';
    }
    if (stage && !stage.querySelector('.pelyko-lifestyle-caption')) {
      const caption = document.createElement('span');
      caption.className = 'pelyko-lifestyle-caption';
      caption.textContent = 'Une routine plus simple, avec eux.';
      stage.appendChild(caption);
    }
  };

  const productMessages = {
    'brosse-autonettoyante-pelyko-chien-chat': {
      fit: 'Votre chien ou chat perd régulièrement ses poils.',
      benefit: 'Retirer les poils détachés avant le canapé.',
      diff: 'Bouton autonettoyant : les poils se libèrent en un geste.'
    },
    'gant-de-toilettage-pelyko-douceur-chien-chat': {
      fit: 'Votre animal préfère la main à une brosse classique.',
      benefit: 'Un toilettage plus doux, proche de la caresse.',
      diff: 'Le gant suit votre main pour mieux doser la pression.'
    },
    'brosse-de-bain-pelyko-mousse-reservoir-integre': {
      fit: 'Le bain vous demande toujours une main de trop.',
      benefit: 'Shampooing + massage dans le même geste.',
      diff: 'Le réservoir est intégré directement dans la brosse.'
    },
    'collecteur-de-poils-pelyko-maison-reutilisable': {
      fit: 'Les poils s’accrochent au canapé, vêtements ou sièges.',
      benefit: 'Des retouches rapides sans rouleau jetable.',
      diff: 'Réutilisable, sans feuilles adhésives à racheter.'
    }
  };

  const addProduct = () => {
    const pdp = document.querySelector('.pelyko-pdp');
    if (!pdp) return;
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    const data = match ? productMessages[match[1]] : null;
    if (!data) return;
    pdp.classList.add('is-pelyko-conversion');

    const info = pdp.querySelector('.pelyko-pdp-info');
    const heading = info?.querySelector('h1');
    if (!info || !heading) return;

    if (!info.querySelector('.pelyko-pdp-rating')) {
      const rating = document.createElement('div');
      rating.className = 'pelyko-pdp-rating';
      rating.innerHTML = `
        <span class="pelyko-pdp-rating__stars" aria-hidden="true">★★★★★</span>
        <strong>4,8/5</strong>
        <span class="pelyko-pdp-rating__label">Avis clients</span>
        <a href="/#avis">Voir les avis</a>
        <small class="pelyko-preview-tag">Aperçu</small>`;
      heading.insertAdjacentElement('afterend', rating);
    }

    if (!info.querySelector('.pelyko-pdp-conversion-answers')) {
      const answers = document.createElement('div');
      answers.className = 'pelyko-pdp-conversion-answers';
      answers.setAttribute('aria-label', 'Les trois réponses essentielles pour ce produit');
      answers.innerHTML = `
        <div class="pelyko-pdp-conversion-answer"><b>Pour vous ?</b><span>${data.fit}</span></div>
        <div class="pelyko-pdp-conversion-answer"><b>Le bénéfice</b><span>${data.benefit}</span></div>
        <div class="pelyko-pdp-conversion-answer"><b>La différence</b><span>${data.diff}</span></div>`;
      const rating = info.querySelector('.pelyko-pdp-rating');
      rating.insertAdjacentElement('afterend', answers);
    }
  };

  const apply = () => { addHome(); addProduct(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
  else apply();
})();
